const partnerManagerResources = {
    labelFirstName: 'First Name',
    labelLastName: 'Last Name',
    labelEmailAddress: 'Email Address',
    errorMessagePasswordConfirmPasswordMatch: 'Password and Confirm Password must match.',
    addManagerButtonText: 'Add Manager'
};
export default partnerManagerResources;
